const isTokenAboutToExpire = (token: string | null) => {
    const refreshTokenMinutes = 120; // 240 equals 4 minutes

    if (token) {
        const arrayToken = token.split('.');

        const tokenPayload = JSON.parse(atob(arrayToken[1]));

        const currentDate = Math.floor(Date.now() / 1000); // Se obtiene la fecha actual y se convierte
        const newDate = currentDate + refreshTokenMinutes; // Se agregan 4 minutos a la fecha actual

        return tokenPayload.exp <= newDate; // Si el token es menor al tiempo estimado -- Esta proximo a vencer
    } else {
        return null;
    }
};

const getExpirationDate = (token: string | null) => {
    if (token) {
        const arrayToken = token.split('.');
        const tokenPayload = JSON.parse(atob(arrayToken[1]));

        const date = new Date(tokenPayload.exp * 1000);

        return date.toUTCString();
    } else {
        return null;
    }
};

export const manageTokenService = {
    isTokenAboutToExpire: isTokenAboutToExpire,
    expirationDate: getExpirationDate,
};
